module.exports = __webpack_public_path__ + "img/beta-o.e066cc18.svg";